<template>
  <el-dialog
    v-model="bindPhoneVisible"
    title="绑定手机号"
    width="90%"
    :close-on-click-modal="false"
    @close="skipBindPhone"
  >
    <el-form :model="bindPhoneForm" :rules="bindPhoneRules" ref="bindPhoneFormRef">
      <el-form-item prop="phone">
        <el-input v-model="bindPhoneForm.phone" placeholder="请输入手机号码" maxlength="11" clearable>
          <template #prefix><el-icon><Phone /></el-icon></template>
        </el-input>
      </el-form-item>
      <el-form-item prop="code">
        <div class="verification-code">
          <el-input v-model="bindPhoneForm.code" placeholder="请输入验证码" maxlength="6" clearable>
            <template #prefix><el-icon><Key /></el-icon></template>
          </el-input>
          <el-button type="primary" :disabled="bindCooldown > 0" @click="sendBindPhoneCode">
            {{ bindCooldown > 0 ? `${bindCooldown}秒后重试` : '获取验证码' }}
          </el-button>
        </div>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="skipBindPhone">稍后再说</el-button>
      <el-button type="primary" :loading="bindPhoneLoading" @click="submitBindPhone">确认绑定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { ElMessage } from 'element-plus'
import { Phone, Key } from '@element-plus/icons-vue'
import { setUserInfo } from '@/utils/auth'
import { sendSmsCode, getUserInfo, bindPhone } from '@/api/auth'
import {
  processWechatBindOAuthReturn,
  syncWechatBoundFlag,
  BIND_PHONE_PROMPT_EVENT
} from '@/utils/accountBind'

export default {
  name: 'AccountBindPrompt',
  components: { Phone, Key },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号码'))
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
    return {
      bindPhoneVisible: false,
      bindPhoneLoading: false,
      bindCooldown: 0,
      bindPhoneForm: { phone: '', code: '' },
      bindPhoneMsgId: '',
      bindPhoneRules: {
        phone: [{ validator: validatePhone, trigger: 'blur' }],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { min: 6, max: 6, message: '验证码为6位数字', trigger: 'blur' }
        ]
      },
      removeRouterHook: null
    }
  },
  mounted() {
    this.onBindPhonePrompt = () => {
      this.bindPhoneVisible = true
    }
    window.addEventListener(BIND_PHONE_PROMPT_EVENT, this.onBindPhonePrompt)
    this.processOAuthBindReturn()
    this.removeRouterHook = this.$router.afterEach(() => {
      this.$nextTick(() => this.processOAuthBindReturn())
    })
  },
  beforeUnmount() {
    window.removeEventListener(BIND_PHONE_PROMPT_EVENT, this.onBindPhonePrompt)
    if (this.removeRouterHook) {
      this.removeRouterHook()
    }
  },
  methods: {
    async processOAuthBindReturn() {
      await processWechatBindOAuthReturn()
    },
    sendBindPhoneCode() {
      this.$refs.bindPhoneFormRef.validateField('phone', (valid) => {
        if (!valid) return
        sendSmsCode(this.bindPhoneForm.phone).then(response => {
          const payload = response.data || {}
          if (!payload.msgId) {
            ElMessage.error('验证码发送失败，未获取到 msgId')
            return
          }
          this.bindPhoneMsgId = payload.msgId
          this.bindCooldown = 60
          const timer = setInterval(() => {
            this.bindCooldown--
            if (this.bindCooldown <= 0) clearInterval(timer)
          }, 1000)
          ElMessage.success(`验证码已发送至 ${this.bindPhoneForm.phone}`)
        }).catch(error => {
          ElMessage.error(error.message || '验证码发送失败')
        })
      })
    },
    submitBindPhone() {
      this.$refs.bindPhoneFormRef.validate((valid) => {
        if (!valid) return
        this.bindPhoneLoading = true
        bindPhone(this.bindPhoneForm.phone, this.bindPhoneForm.code, this.bindPhoneMsgId)
          .then(async () => {
            const userInfo = await getUserInfo()
            setUserInfo(userInfo)
            syncWechatBoundFlag(userInfo)
            this.bindPhoneVisible = false
            ElMessage.success('手机号绑定成功')
          })
          .catch(error => {
            ElMessage.error(error.message || '绑定失败')
          })
          .finally(() => {
            this.bindPhoneLoading = false
          })
      })
    },
    skipBindPhone() {
      this.bindPhoneVisible = false
    }
  }
}
</script>

<style scoped>
.verification-code {
  display: flex;
  width: 100%;
}
.verification-code .el-input {
  flex: 1;
  margin-right: 10px;
}
.verification-code .el-button {
  width: 110px;
  font-size: 12px;
}
</style>
